import styled from "styled-components";
import { BaseGridContainer } from "../../utils/styles";
export const ProductsWrap = styled(BaseGridContainer) `
	height: auto;
	margin: 12px auto;
`;
export const Arrow = styled.div `
	position: absolute;
	width: 30px;
	height: 54px;
	background: #000000;
	opacity: 0.15;
	z-index: 1;
	cursor: pointer;
	top: 50%;
	margin-top: -27px;
	:hover {
		opacity: 0.5;
	}
	&:after {
		display: inline-block;
		content: " ";
		height: 14px;
		width: 14px;
		border-color: #fff;
		border-style: solid;
		border-width: 2px 2px 0 0;
		position: absolute;
		top: 50%;
		margin-top: -7px;
		-webkit-transition: 0.3s;
		transition: 0.3s;
	}
`;
export const TomatoLeftArrow = styled(Arrow) `
	border-radius: 4px 0px 0px 4px;
	left: 0px;
	&:after {
		left: 50%;
		margin-left: -5px;
		transform: rotate(-135deg);
	}
`;
export const TomatoRightArrow = styled(Arrow) `
	right: 0px;
	border-radius: 4px 0px 0px 4px;
	&:after {
		right: 50%;
		margin-right: -5px;
		transform: rotate(45deg);
	}
`;
